// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

import { Component } from '@angular/core';
/**
 * @internal
 * Not for public use
 */
@Component({
  selector: 'lf-general-dialog-layout',
  templateUrl: './general-dialog-layout.component.html',
  styleUrls: ['./general-dialog-layout.component.css'],
  standalone: true,
  imports: [],
})
export class GeneralDialogLayoutComponent {}
